"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const commandCell = (mode, row) => ({
    position: 'sticky',
    left: 0,
    textAlign: 'center',
    backgroundColor: mode == 'dark' ? row % 2 == 0 ? '#272936' : 'inherit' : 'none',
});
const editIcon = {
    fontSize: 'large',
    cursor: 'pointer',
    marginRight: 5,
    color: '#404041'
};
const deleteIcon = {
    fontSize: 'large',
    cursor: 'pointer',
    color: '#404041'
};
const icon = (margin) => ({
    fontSize: 'large',
    cursor: 'pointer',
    marginRight: margin ? 5 : undefined,
    color: '#404041'
});
const statusStyle = status => ({
    textAlign: 'center',
    color: status === 'Success' ? '#4C8C8C' : status === 'On Progress' ? '#FFC700' : '#BA352C'
});
const logTextStyle = {
    cursor: 'pointer',
    textAlign: 'center',
    textDecorationLine: 'underline'
};
const rfidScanDeleteWrapper = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};
const buttonSave = theme => ({
    padding: '0 5px',
    display: 'flex',
    fontSize: 'large',
    fontWeight: 'normal',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: constants_1.color.white,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'light' ? constants_1.color.redDark : constants_1.color.buttonDark,
    height: 40,
    minWidth: 95,
    borderRadius: 10,
    marginRight: 16
});
const btnStyle = {
    fontSize: 16,
};
const buttonDelete = theme => ({
    padding: '0 5px',
    display: 'flex',
    fontSize: 'large',
    fontWeight: 'normal',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: theme === 'dark' ? constants_1.color.black : constants_1.color.white,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'light' ? ' #404041' : constants_1.color.white,
    height: 40,
    minWidth: 95,
    borderRadius: 10,
    marginRight: 16
});
const rfidTag = {
    display: 'flex',
    width: 422,
    height: 40,
    padding: '10px 8px',
    background: '#F5F6F7',
    border: '2px solid #DEE0E5',
    borderRadius: 3,
    color: constants_1.color.black
};
const textLinkCell = {
    color: '#2D72EA',
    cursor: 'pointer',
};
const duplicatedBoxWrapper = {
    display: 'flex',
    justifyContent: 'center'
};
const duplicatedBox = {
    width: 16,
    height: 16,
    borderRadius: 4,
    backgroundColor: constants_1.color.redDark
};
const notDuplicatedBox = {
    width: 16,
    height: 16,
    borderRadius: 4,
    backgroundColor: '#4C8C8C'
};
exports.default = {
    icon,
    rfidTag,
    editIcon,
    btnStyle,
    deleteIcon,
    buttonSave,
    commandCell,
    statusStyle,
    logTextStyle,
    buttonDelete,
    textLinkCell,
    duplicatedBox,
    notDuplicatedBox,
    duplicatedBoxWrapper,
    rfidScanDeleteWrapper,
};
